export function getUtilizationClass(value) {
  if (value >= 70) return "utilization-bar__fill--high";
  if (value >= 40) return "utilization-bar__fill--medium";
  return "utilization-bar__fill--low";
}
